import { FileActionButton } from "../file-action/file-action-controls";
// import { DataTable } from "primereact/datatable";
// import { Column } from "primereact/column";
// import { Tag } from "primereact/tag";
// import { MultiSelect } from "primereact/multiselect";
// import { Button } from "primereact/button";
// import { useState, useMemo, useImperativeHandle, forwardRef } from "react";

// // Define type of a movement log row (you can adjust as needed)
// interface MovementLog {
//   movementType: string;
//   createdDate: string;
//   productName: string;
//   quantity: number;
//   sourceType: string;
//   sourceValue: string | null;
//   documentDetails: string;
//   note: string;
// }

// interface MovementLogTableProps {
//   data: MovementLog[];
//   loading: boolean;
//   keyword: string;
// }

// export const MovementLogTable = forwardRef<{ resetFilters: () => void }, MovementLogTableProps>(
//   ({ data, loading, keyword }, ref) => {
//     // Filter state
//     const [typeFilter, setTypeFilter] = useState<string[]>([]);
//     const [productFilter, setProductFilter] = useState<string[]>([]);
//     const [sourceTypeFilter, setSourceTypeFilter] = useState<string[]>([]);
//     const [sourceRefFilter, setSourceRefFilter] = useState<string[]>([]);

//     // Sort state
//     const [sortField, setSortField] = useState<string | null>(null);
//     const [sortOrder, setSortOrder] = useState<1 | -1>(1); // 1 = asc, -1 = desc

//     // Expose reset function to parent component
//     useImperativeHandle(ref, () => ({
//       resetFilters: () => {
//         setTypeFilter([]);
//         setProductFilter([]);
//         setSourceTypeFilter([]);
//         setSourceRefFilter([]);
//         setSortField(null);
//         setSortOrder(1);
//       }
//     }));

//     // Sort data by date (newest first) as base
//     const sortedData = useMemo(() => {
//       if (!data || data.length === 0) return [];
//       return [...data].sort((a, b) => new Date(b.createdDate).getTime() - new Date(a.createdDate).getTime());
//     }, [data]);

//     // Apply all filters to get filtered data
//     const filteredData = useMemo(() => {
//       let filtered = sortedData;

//       // Apply keyword search across all columns
//       if (keyword.trim()) {
//         const searchTerm = keyword.toLowerCase();
//         filtered = filtered.filter(item =>
//           item.movementType?.toLowerCase().includes(searchTerm) ||
//           item.productName?.toLowerCase().includes(searchTerm) ||
//           item.sourceType?.toLowerCase().includes(searchTerm) ||
//           item.sourceValue?.toLowerCase().includes(searchTerm) ||
//           item.documentDetails?.toLowerCase().includes(searchTerm) ||
//           item.note?.toLowerCase().includes(searchTerm) ||
//           item.quantity?.toString().includes(searchTerm)
//         );
//       }

//       if (typeFilter.length > 0) {
//         filtered = filtered.filter(item => typeFilter.includes(item.movementType));
//       }
//       if (productFilter.length > 0) {
//         filtered = filtered.filter(item => productFilter.includes(item.productName));
//       }
//       if (sourceTypeFilter.length > 0) {
//         filtered = filtered.filter(item => sourceTypeFilter.includes(item.sourceType));
//       }
//       if (sourceRefFilter.length > 0) {
//         filtered = filtered.filter(item => item.sourceValue && sourceRefFilter.includes(item.sourceValue));
//       }

//       // Apply sorting if a sort field is selected
//       if (sortField) {
//         filtered = [...filtered].sort((a, b) => {
//           const aVal = a[sortField as keyof MovementLog];
//           const bVal = b[sortField as keyof MovementLog];

//           if (aVal === null || aVal === undefined) return 1;
//           if (bVal === null || bVal === undefined) return -1;

//           if (typeof aVal === 'string' && typeof bVal === 'string') {
//             return sortOrder * aVal.localeCompare(bVal);
//           }

//           if (typeof aVal === 'number' && typeof bVal === 'number') {
//             return sortOrder * (aVal - bVal);
//           }

//           return 0;
//         });
//       }

//       return filtered;
//     }, [sortedData, typeFilter, productFilter, sourceTypeFilter, sourceRefFilter, keyword, sortField, sortOrder]);

//     // Get unique values for each filter column based on current filtered data
//     const getUniqueValues = (field: keyof MovementLog, currentFilters: Partial<Record<keyof MovementLog, string[]>>): string[] => {
//       if (!sortedData || sortedData.length === 0) return [];

//       let baseData = sortedData;

//       // Apply all other filters except the current one to get cascading effect
//       if (currentFilters.movementType && field !== 'movementType') {
//         baseData = baseData.filter(item => currentFilters.movementType!.includes(item.movementType));
//       }
//       if (currentFilters.productName && field !== 'productName') {
//         baseData = baseData.filter(item => currentFilters.productName!.includes(item.productName));
//       }
//       if (currentFilters.sourceType && field !== 'sourceType') {
//         baseData = baseData.filter(item => currentFilters.sourceType!.includes(item.sourceType));
//       }
//       if (currentFilters.sourceValue && field !== 'sourceValue') {
//         baseData = baseData.filter(item => item.sourceValue && currentFilters.sourceValue!.includes(item.sourceValue));
//       }

//       const uniqueValues = Array.from(new Set(baseData.map(item => item[field]).filter(val => val !== null && val !== undefined))) as string[];
//       return uniqueValues.sort();
//     };

//     // Current filter state for cascading
//     const currentFilters = useMemo(() => ({
//       movementType: typeFilter.length > 0 ? typeFilter : undefined,
//       productName: productFilter.length > 0 ? productFilter : undefined,
//       sourceType: sourceTypeFilter.length > 0 ? sourceTypeFilter : undefined,
//       sourceValue: sourceRefFilter.length > 0 ? sourceRefFilter : undefined,
//     }), [typeFilter, productFilter, sourceTypeFilter, sourceRefFilter]);

//     // Get available options for each filter
//     const typeOptions = useMemo(() => getUniqueValues('movementType', currentFilters), [sortedData, currentFilters]);
//     const productOptions = useMemo(() => getUniqueValues('productName', currentFilters), [sortedData, currentFilters]);
//     const sourceTypeOptions = useMemo(() => getUniqueValues('sourceType', currentFilters), [sortedData, currentFilters]);
//     const sourceRefOptions = useMemo(() => getUniqueValues('sourceValue', currentFilters), [sortedData, currentFilters]);

//     // Clear all filters
//     const clearAllFilters = () => {
//       setTypeFilter([]);
//       setProductFilter([]);
//       setSourceTypeFilter([]);
//       setSourceRefFilter([]);
//       setSortField(null);
//       setSortOrder(1);
//     };

//     // Handle sorting
//     const handleSort = (field: string) => {
//       if (sortField === field) {
//         // Toggle sort order
//         setSortOrder(sortOrder === 1 ? -1 : 1);
//       } else {
//         // New field, set to ascending
//         setSortField(field);
//         setSortOrder(1);
//       }
//     };

//     // Check if any filters are active
//     const hasActiveFilters = typeFilter.length > 0 || productFilter.length > 0 ||
//       sourceTypeFilter.length > 0 || sourceRefFilter.length > 0 || keyword.trim() !== "";

//     // Export function to convert data to CSV and download
//     const exportToCSV = () => {
//       if (filteredData.length === 0) {
//         return;
//       }

//       // Define CSV headers
//       const headers = ['Type', 'Date', 'Product', 'Quantity', 'Source Type', 'Source / Reference', 'Document Details', 'Note'];

//       // Convert data to CSV rows
//       const csvRows = filteredData.map(row => {
//         const dt = new Date(row.createdDate);
//         const formattedDate = dt.toLocaleDateString('en-GB');

//         return [
//           row.movementType || '',
//           formattedDate,
//           row.productName || '',
//           row.quantity?.toString() || '',
//           row.sourceType || '',
//           row.sourceValue || '',
//           row.documentDetails || '',
//           row.note || ''
//         ].map(field => {
//           // Escape fields that contain commas, quotes, or newlines
//           const escaped = field.replace(/"/g, '""');
//           return escaped.includes(',') || escaped.includes('"') || escaped.includes('\n')
//             ? `"${escaped}"`
//             : escaped;
//         }).join(',');
//       });

//       // Combine headers and rows
//       const csvContent = [headers.join(','), ...csvRows].join('\n');

//       // Create blob and download
//       const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
//       const link = document.createElement('a');
//       const url = URL.createObjectURL(blob);

//       link.setAttribute('href', url);
//       link.setAttribute('download', `movement_log_${new Date().toISOString().split('T')[0]}.csv`);
//       link.style.visibility = 'hidden';

//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);
//     };

//     // Custom cell for 'type' - colored text with background
//     const typeBody = (rowData: MovementLog) => {
//       let color: string;
//       let backgroundColor: string;

//       switch (rowData.movementType) {
//         case "Inward":
//           color = "#22c55e"; // Green
//           backgroundColor = "#f0fdf4"; // Light green background
//           break;
//         case "Outward":
//           color = "#3b82f6"; // Blue
//           backgroundColor = "#eff6ff"; // Light blue background
//           break;
//         case "Adjust":
//           color = "#f59e0b"; // Orange/Amber
//           backgroundColor = "#fffbeb"; // Light orange background
//           break;
//         default:
//           color = "#6b7280"; // Gray
//           backgroundColor = "#f9fafb"; // Light gray background
//       }

//       return (
//         <span style={{
//           color: color,
//           backgroundColor: backgroundColor,
//           padding: '4px 12px',
//           borderRadius: '6px',
//           fontWeight: '500',
//           fontSize: '0.875rem'
//         }}>
//           {rowData.movementType}
//         </span>
//       );
//     };

//     const dateBody = (rowData: MovementLog) => {
//       const dt = new Date(rowData.createdDate);
//       return dt.toLocaleDateString('en-GB');
//     };

//     // Filterable column header component
//     const FilterableColumnHeader = ({
//       title,
//       filterValue,
//       onFilterChange,
//       options,
//       sortField: columnField,
//       showSort = true
//     }: {
//       title: string;
//       filterValue: string[];
//       onFilterChange: (value: string[]) => void;
//       options: string[];
//       sortField?: string;
//       showSort?: boolean;
//     }) => {
//       const isCurrentlySorted = sortField === columnField;
//       const activeFilterCount = filterValue.length;

//       return (
//         <div className="flex align-items-center gap-2" style={{ whiteSpace: 'nowrap' }}>
//           <span className="font-semibold">{title}</span>

//           <div className="flex align-items-center gap-1">
//             {/* Filter dropdown */}
//             <div className="p-overlay-badge">
//               <MultiSelect
//                 value={filterValue}
//                 options={options}
//                 onChange={(e) => onFilterChange(e.value)}
//                 placeholder={`Filter ${title}`}
//                 maxSelectedLabels={0}
//                 selectedItemsLabel={`${activeFilterCount} selected`}
//                 className="custom-multiselect"
//                 style={{
//                   width: '40px',
//                   height: '32px',
//                 }}
//                 panelStyle={{ minWidth: '200px' }}
//                 display="chip"
//                 pt={{
//                   root: {
//                     style: {
//                       border: activeFilterCount > 0 ? '2px solid #22c55e' : '1px solid #d1d5db',
//                       borderRadius: '6px',
//                       background: activeFilterCount > 0 ? '#f0fdf4' : 'white',
//                       transition: 'all 0.3s ease',
//                     }
//                   },
//                   trigger: {
//                     style: {
//                       width: '100%',
//                       padding: '0',
//                       display: 'flex',
//                       alignItems: 'center',
//                       justifyContent: 'center'
//                     }
//                   },
//                   label: {
//                     style: { display: 'none' }
//                   }
//                 }}
//               >
//                 <template>
//                   <div className="flex align-items-center justify-content-center" style={{ width: '100%' }}>
//                     <i
//                       className="pi pi-filter"
//                       style={{
//                         fontSize: '0.9rem',
//                         color: activeFilterCount > 0 ? '#22c55e' : '#6b7280'
//                       }}
//                     />
//                     {activeFilterCount > 0 && (
//                       <span
//                         className="ml-1 badge-custom"
//                         style={{
//                           background: '#22c55e',
//                           color: 'white',
//                           borderRadius: '10px',
//                           padding: '0 5px',
//                           fontSize: '0.65rem',
//                           fontWeight: 'bold',
//                           minWidth: '16px',
//                           textAlign: 'center'
//                         }}
//                       >
//                         {activeFilterCount}
//                       </span>
//                     )}
//                   </div>
//                 </template>
//               </MultiSelect>
//             </div>

//             {/* Sort buttons */}
//             {showSort && columnField && (
//               <Button
//                 icon={isCurrentlySorted && sortOrder === -1 ? "pi pi-sort-amount-down" : "pi pi-sort-amount-up"}
//                 className="p-button-text p-button-sm"
//                 onClick={() => handleSort(columnField)}
//                 style={{
//                   color: isCurrentlySorted ? '#22c55e' : '#6b7280',
//                   padding: '4px 8px',
//                   minWidth: 'auto',
//                   transition: 'all 0.3s ease'
//                 }}
//                 tooltip={`Sort ${isCurrentlySorted ? (sortOrder === 1 ? 'Descending' : 'Ascending') : 'Ascending'}`}
//                 tooltipOptions={{ position: 'top' }}
//               />
//             )}
//           </div>
//         </div>
//       );
//     };

//     return (
//       <div className="col-12">
//         {/* Section Header */}
//         <div className="flex align-items-center gap-2 mb-3 px-2">
//           <div style={{
//             backgroundColor: 'rgb(76, 175, 80)',
//             borderRadius: '8px',
//             padding: '8px',
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'center'
//           }}>
//             <i className="pi pi-list" style={{ color: 'white', fontSize: '1.2rem' }}></i>
//           </div>
//           <span style={{ fontWeight: '600', color: '#2d3748', fontSize: '1.1rem' }}>Movement Records</span>
//         </div>

//         <div className="card p-2" style={{ borderRadius: '12px' }}>
//           {/* Header Actions: Export and Clear Filters */}
//           {(filteredData.length > 0 || hasActiveFilters) && (
//             <div className="flex justify-content-end mb-2 gap-2">
//               {/* Export Button */}
//               {filteredData.length > 0 && (
//                 <Button
//                   label="Export"
//                   icon="pi pi-download"
//                   className="export-btn-summary-tooltip"
//                   onClick={exportToCSV}
//                   style={{
//                     backgroundColor: '#22c55e',
//                     border: 'none',
//                     color: 'white',
//                     borderRadius: '6px',
//                     padding: '0.5rem 1rem',
//                     fontSize: '0.9rem'
//                   }}
//                   onMouseEnter={(e) => {
//                     e.currentTarget.style.background = '#22c55e';
//                     e.currentTarget.style.color = 'white';
//                   }}
//                   onMouseLeave={(e) => {
//                     e.currentTarget.style.background = 'transparent';
//                     e.currentTarget.style.color = '#22c55e';
//                   }}
//                   tooltip={`Export ${filteredData.length} record${filteredData.length !== 1 ? 's' : ''} to CSV`}
//                   tooltipOptions={{ position: 'top' }}
//                 />
//               )}

//               {/* Clear All Filters Button */}
//               {hasActiveFilters && (
//                 <Button
//                   label="Clear All Filters"
//                   icon="pi pi-filter-slash"
//                   className="p-button-outlined p-button-sm"
//                   onClick={clearAllFilters}
//                   style={{
//                     borderColor: '#22c55e',
//                     color: '#22c55e',
//                     transition: 'all 0.3s ease'
//                   }}
//                   onMouseEnter={(e) => {
//                     e.currentTarget.style.background = '#22c55e';
//                     e.currentTarget.style.color = 'white';
//                   }}
//                   onMouseLeave={(e) => {
//                     e.currentTarget.style.background = 'transparent';
//                     e.currentTarget.style.color = '#22c55e';
//                   }}
//                 />
//               )}
//             </div>
//           )}

//           <DataTable
//             value={filteredData}
//             loading={loading}
//             paginator
//             rows={10}
//             rowsPerPageOptions={[10, 25, 50, 100]}
//             paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
//             currentPageReportTemplate="{first} to {last} of {totalRecords}"
//             emptyMessage="No records found"
//             stripedRows
//             className="pos-movements-table"
//           >
//             <Column
//               body={typeBody}
//               header={
//                 <FilterableColumnHeader
//                   title="Type"
//                   filterValue={typeFilter}
//                   onFilterChange={setTypeFilter}
//                   options={typeOptions}
//                   sortField="movementType"
//                 />
//               }
//               style={{ minWidth: '11rem' }}
//             />

//             <Column
//               header="Date"
//               body={dateBody}
//               style={{ minWidth: '7.5rem' }}
//             />

//             <Column
//               field="productName"
//               header={
//                 <FilterableColumnHeader
//                   title="Product"
//                   filterValue={productFilter}
//                   onFilterChange={setProductFilter}
//                   options={productOptions}
//                   sortField="productName"
//                 />
//               }
//               style={{ minWidth: '14rem' }}
//             />

//             <Column
//               field="quantity"
//               header="Quantity"
//               sortable
//               style={{ minWidth: '7rem' }}
//             />

//             <Column
//               field="sourceType"
//               header={
//                 <FilterableColumnHeader
//                   title="Source Type"
//                   filterValue={sourceTypeFilter}
//                   onFilterChange={setSourceTypeFilter}
//                   options={sourceTypeOptions}
//                   sortField="sourceType"
//                 />
//               }
//               style={{ minWidth: '12.5rem' }}
//             />

//             <Column
//               field="sourceValue"
//               header={
//                 <FilterableColumnHeader
//                   title="Source / Reference"
//                   filterValue={sourceRefFilter}
//                   onFilterChange={setSourceRefFilter}
//                   options={sourceRefOptions}
//                   sortField="sourceValue"
//                 />
//               }
//               style={{ minWidth: '14rem' }}
//             />

//             <Column
//               field="documentDetails"
//               header="Document Details"
//               sortable
//               style={{ minWidth: '11rem' }}
//             />

//             <Column
//               field="note"
//               header="Note"
//               sortable
//               style={{ minWidth: '9.5rem' }}
//             />
//           </DataTable>

//           <style>{`
//           .custom-multiselect .p-multiselect-trigger {
//             padding: 0 !important;
//           }

//           .custom-multiselect .p-multiselect-label {
//             display: none !important;
//           }

//           .pos-movements-table .p-datatable-thead > tr > th {
//             background: linear-gradient(to bottom, #f9fafb, #f3f4f6);
//             border-bottom: 2px solid #e5e7eb;
//             padding: 1rem 0.75rem;
//           }

//           .pos-movements-table .p-datatable-thead > tr > th:hover {
//             background: linear-gradient(to bottom, #f0fdf4, #dcfce7);
//             transition: background 0.3s ease;
//           }

//           .pos-movements-table .p-multiselect-panel .p-multiselect-header {
//             background: #f0fdf4;
//             border-bottom: 2px solid #22c55e;
//           }

//           .pos-movements-table .p-multiselect-panel .p-multiselect-item:hover {
//             background: #dcfce7;
//           }

//           .pos-movements-table .p-multiselect-panel .p-multiselect-item.p-highlight {
//             background: #22c55e;
//             color: white;
//           }

//           .pos-movements-table .p-button:hover {
//             transform: scale(1.1);
//             transition: transform 0.2s ease;
//           }
//         `}</style>
//         </div>
//       </div>
//     );
//   }
// );

// MovementLogTable.displayName = 'MovementLogTable';
//
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Tag } from "primereact/tag";
import { MultiSelect } from "primereact/multiselect";
import { Button } from "primereact/button";
import { useState, useMemo, useImperativeHandle, forwardRef, useRef } from "react";
import { Dialog } from "primereact/dialog";
import { Toast } from "primereact/toast";
import { Dropdown, DropdownChangeEvent, DropdownFilterEvent } from "primereact/dropdown";
import * as ExcelJS from "exceljs";
import orderServices from "../../services/orders/orderservice";
import ProductStorageHelpers from "../../utils/product-local-storage-wrapper";
import api from "../../services/api";

// Define type of a movement log row (you can adjust as needed)
interface MovementLog {
  movementType: string;
  createdDate: string;
  productName: string;
  quantity: number;
  sourceType: string;
  sourceValue: string | null;
  documentDetails: string;
  note: string;
  createdByName: string | null;
  createdByPhone: string | null;
}


interface MovementLogTableProps {
  data: MovementLog[];
  loading: boolean;
  keyword: string;
}

interface AdminUserOption {
  userID: number;
  name: string;
  primaryContactNbr: string;
}


interface AdminUserOption {
  userID: number;
  name: string;
  primaryContactNbr: string;
}

export const MovementLogTable = forwardRef<{ resetFilters: () => void }, MovementLogTableProps>(
  ({ data, loading, keyword }, ref) => {
    const toastRef = useRef<Toast>(null);
    const [showWhatsAppModal, setShowWhatsAppModal] = useState(false);
    const [recipientPhone, setRecipientPhone] = useState("");
    const [isSendingWhatsApp, setIsSendingWhatsApp] = useState(false);
    const recentAdminsStorageKey = "pos-movement-whatsapp-recent-admins";
    const blankAdmins: AdminUserOption[] = [{ userID: 0, name: "Search by User", primaryContactNbr: "" }];
    const [admins, setAdmins] = useState<AdminUserOption[]>(blankAdmins);
    const [selectedAdminId, setSelectedAdminId] = useState<number | null>(null);
    const [lockedField, setLockedField] = useState<"admin" | "phone" | null>(null);


    // Filter state
    const [typeFilter, setTypeFilter] = useState<string[]>([]);
    const [productFilter, setProductFilter] = useState<string[]>([]);
    const [sourceTypeFilter, setSourceTypeFilter] = useState<string[]>([]);
    const [sourceRefFilter, setSourceRefFilter] = useState<string[]>([]);

    // Sort state
    const [sortField, setSortField] = useState<string | null>(null);
    const [sortOrder, setSortOrder] = useState<1 | -1>(1); // 1 = asc, -1 = desc


    // Expose reset function to parent component
    useImperativeHandle(ref, () => ({
      resetFilters: () => {
        setTypeFilter([]);
        setProductFilter([]);
        setSourceTypeFilter([]);
        setSourceRefFilter([]);
        setSortField(null);
        setSortOrder(1);
      }
    }));


    // Sort data by date (newest first) as base
    const sortedData = useMemo(() => {
      if (!data || data.length === 0) return [];
      return [...data].sort((a, b) => new Date(b.createdDate).getTime() - new Date(a.createdDate).getTime());
    }, [data]);


    // Apply all filters to get filtered data
    const filteredData = useMemo(() => {
      let filtered = sortedData;


      // Apply keyword search across all columns
      if (keyword.trim()) {
        const searchTerm = keyword.toLowerCase();
        filtered = filtered.filter(item =>
          item.movementType?.toLowerCase().includes(searchTerm) ||
          item.productName?.toLowerCase().includes(searchTerm) ||
          item.sourceType?.toLowerCase().includes(searchTerm) ||
          item.sourceValue?.toLowerCase().includes(searchTerm) ||
          item.documentDetails?.toLowerCase().includes(searchTerm) ||
          item.note?.toLowerCase().includes(searchTerm) ||
          item.quantity?.toString().includes(searchTerm) ||
          item.createdByName?.toLowerCase().includes(searchTerm) ||
          item.createdByPhone?.toLowerCase().includes(searchTerm)

        );
      }


      if (typeFilter.length > 0) {
        filtered = filtered.filter(item => typeFilter.includes(item.movementType));
      }
      if (productFilter.length > 0) {
        filtered = filtered.filter(item => productFilter.includes(item.productName));
      }
      if (sourceTypeFilter.length > 0) {
        filtered = filtered.filter(item => sourceTypeFilter.includes(item.sourceType));
      }
      if (sourceRefFilter.length > 0) {
        filtered = filtered.filter(item => item.sourceValue && sourceRefFilter.includes(item.sourceValue));
      }


      // Apply sorting if a sort field is selected
      if (sortField) {
        filtered = [...filtered].sort((a, b) => {
          const aVal = a[sortField as keyof MovementLog];
          const bVal = b[sortField as keyof MovementLog];


          if (aVal === null || aVal === undefined) return 1;
          if (bVal === null || bVal === undefined) return -1;


          if (typeof aVal === 'string' && typeof bVal === 'string') {
            return sortOrder * aVal.localeCompare(bVal);
          }


          if (typeof aVal === 'number' && typeof bVal === 'number') {
            return sortOrder * (aVal - bVal);
          }


          return 0;
        });
      }


      return filtered;
    }, [sortedData, typeFilter, productFilter, sourceTypeFilter, sourceRefFilter, keyword, sortField, sortOrder]);


    // Get unique values for each filter column based on current filtered data
    const getUniqueValues = (field: keyof MovementLog, currentFilters: Partial<Record<keyof MovementLog, string[]>>): string[] => {
      if (!sortedData || sortedData.length === 0) return [];


      let baseData = sortedData;


      // Apply all other filters except the current one to get cascading effect
      if (currentFilters.movementType && field !== 'movementType') {
        baseData = baseData.filter(item => currentFilters.movementType!.includes(item.movementType));
      }
      if (currentFilters.productName && field !== 'productName') {
        baseData = baseData.filter(item => currentFilters.productName!.includes(item.productName));
      }
      if (currentFilters.sourceType && field !== 'sourceType') {
        baseData = baseData.filter(item => currentFilters.sourceType!.includes(item.sourceType));
      }
      if (currentFilters.sourceValue && field !== 'sourceValue') {
        baseData = baseData.filter(item => item.sourceValue && currentFilters.sourceValue!.includes(item.sourceValue));
      }

      const uniqueValues = Array.from(new Set(baseData.map(item => item[field]).filter(val => val !== null && val !== undefined))) as string[];
      return uniqueValues.sort();
    };

    // Current filter state for cascading
    const currentFilters = useMemo(() => ({
      movementType: typeFilter.length > 0 ? typeFilter : undefined,
      productName: productFilter.length > 0 ? productFilter : undefined,
      sourceType: sourceTypeFilter.length > 0 ? sourceTypeFilter : undefined,
      sourceValue: sourceRefFilter.length > 0 ? sourceRefFilter : undefined,
    }), [typeFilter, productFilter, sourceTypeFilter, sourceRefFilter]);

    // Get available options for each filter
    const typeOptions = useMemo(() => getUniqueValues('movementType', currentFilters), [sortedData, currentFilters]);
    const productOptions = useMemo(() => getUniqueValues('productName', currentFilters), [sortedData, currentFilters]);
    const sourceTypeOptions = useMemo(() => getUniqueValues('sourceType', currentFilters), [sortedData, currentFilters]);
    const sourceRefOptions = useMemo(() => getUniqueValues('sourceValue', currentFilters), [sortedData, currentFilters]);

    // Clear all filters
    const clearAllFilters = () => {
      setTypeFilter([]);
      setProductFilter([]);
      setSourceTypeFilter([]);
      setSourceRefFilter([]);
      setSortField(null);
      setSortOrder(1);
    };

    // Handle sorting
    const handleSort = (field: string) => {
      if (sortField === field) {
        // Toggle sort order
        setSortOrder(sortOrder === 1 ? -1 : 1);
      } else {
        // New field, set to ascending
        setSortField(field);
        setSortOrder(1);
      }
    };

    // Check if any filters are active
    const hasActiveFilters = typeFilter.length > 0 || productFilter.length > 0 ||
      sourceTypeFilter.length > 0 || sourceRefFilter.length > 0 || keyword.trim() !== "";
    const hasMatchedAdmin = Boolean(selectedAdminId && selectedAdminId !== 0 && recipientPhone.length === 10);

    // ── Shared Excel generation helper ──────────────────────────────────────
    const buildExcelBuffer = async (): Promise<ArrayBuffer> => {
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Movement Logs');

      worksheet.columns = [
        { header: 'Type', key: 'type', width: 12 },
        { header: 'Date', key: 'date', width: 13 },
        { header: 'Product', key: 'product', width: 30 },
        { header: 'Quantity', key: 'quantity', width: 12 },
        { header: 'Source Type', key: 'sourceType', width: 18 },
        { header: 'Source / Reference', key: 'sourceRef', width: 25 },
        { header: 'Document Details', key: 'details', width: 25 },
        { header: 'Created By', key: 'createdByName', width: 20 },
        { header: 'Phone', key: 'createdByPhone', width: 15 },
        { header: 'Note', key: 'note', width: 20 },
      ];

      const headerRow = worksheet.getRow(1);
      headerRow.font = { bold: true, color: { argb: 'FFFFFFFF' } };
      headerRow.eachCell((cell) => {
        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF8B4513' } };
        cell.alignment = { vertical: 'middle', horizontal: 'center' };
      });

      filteredData.forEach(row => {
        const dt = new Date(row.createdDate);
        const type = row.movementType || '';
        const newRow = worksheet.addRow({
          type,
          date: dt.toLocaleDateString('en-GB'),
          product: row.productName || '',
          quantity: row.quantity || 0,
          sourceType: row.sourceType || '',
          sourceRef: row.sourceValue || '',
          details: row.documentDetails || '',
          createdByName: row.createdByName || '',
          createdByPhone: row.createdByPhone || '',
          note: row.note || ''
        });

        let rowBg = 'FFFFFFFF';
        let rowText = 'FF000000';
        const norm = type.trim().toLowerCase();
        if (norm === 'inward') { rowBg = 'FF5FBF65'; rowText = 'FFFFFFFF'; }
        else if (norm === 'outward') { rowBg = 'FF5A95F5'; rowText = 'FFFFFFFF'; }
        else if (norm === 'adjust') { rowBg = 'FFE7A53A'; rowText = 'FFFFFFFF'; }

        newRow.eachCell({ includeEmpty: true }, (cell) => {
          cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: rowBg } };
          cell.font = { ...(cell.font || {}), color: { argb: rowText } };
          cell.border = {
            top: { style: 'thin', color: { argb: 'FF1F2937' } },
            left: { style: 'thin', color: { argb: 'FF1F2937' } },
            bottom: { style: 'thin', color: { argb: 'FF1F2937' } },
            right: { style: 'thin', color: { argb: 'FF1F2937' } }
          };
        });
        const typeCell = newRow.getCell('type');
        typeCell.font = { ...(typeCell.font || {}), bold: true, color: { argb: rowText } };
      });

      return workbook.xlsx.writeBuffer();
    };

    const handleExportDownload = async () => {
      if (filteredData.length === 0) return;
      try {
        const buffer = await buildExcelBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const link = document.createElement('a');
        link.setAttribute('href', URL.createObjectURL(blob));
        link.setAttribute('download', `Movement_Logs_${new Date().toISOString().split('T')[0]}.xlsx`);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (err) {
        toastRef.current?.show({ severity: 'error', summary: 'Export Failed', detail: 'Could not generate Excel file.', life: 3000 });
      }
    };

    const handleWhatsAppReferral = async () => {
      if (!recipientPhone || recipientPhone.length !== 10 || !hasMatchedAdmin) {
        toastRef.current?.show({
          severity: "warn",
          summary: "Invalid Recipient",
          detail: "Select a valid user from the list before sending WhatsApp.",
          life: 3000,
        });
        return;
      }
      setIsSendingWhatsApp(true);
      try {
        const senderUserId = ProductStorageHelpers.GetUserId() || 0;

        // Step 1: Build Excel
        const buffer = await buildExcelBuffer();
        const excelBlob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

        // Step 2: Upload to server via existing /api/whatsapp/upload-pdf
        // Using a timestamped filename to avoid overwrite issues
        const timestamp = new Date().getTime();
        const excelFile = new File([excelBlob], `Movement_Logs_${timestamp}.xlsx`, {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const formData = new FormData();
        formData.append("pdf", excelFile); // Use field name 'pdf' to match controller

        const uploadResponse = await api.post("/api/whatsapp/upload-pdf", formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        });

        if (uploadResponse.status !== 200) {
          throw new Error("Upload failed");
        }

        const { fileUrl: excelUrl } = uploadResponse.data;
        if (!excelUrl) throw new Error("No URL returned from server");

        // Step 4: Send WhatsApp
        const encodedUrl = encodeURIComponent(excelUrl);
        const messageType = `pos_movement_excel|${recipientPhone}|${encodedUrl}`;

        await orderServices.sendWhatsAppTemplateMessage(senderUserId, messageType);

        toastRef.current?.show({
          severity: "success",
          summary: "Message Sent",
          detail: "WhatsApp message sent successfully!",
          life: 4000,
        });

        resetWhatsAppSelection();
      } catch (error: any) {
        toastRef.current?.show({
          severity: "error",
          summary: "Send Failed",
          detail: error?.message || "Failed to send WhatsApp message.",
          life: 3000,
        });
      } finally {
        setIsSendingWhatsApp(false);
      }
    };

    const handleAdminFilter = (e: DropdownFilterEvent) => {
      if (e.filter.length <= 2) return;
      orderServices
        .getadminuserdetails(e.filter)
        .then((res) => {
          if (res?.length) setAdmins(res);
          else setAdmins(blankAdmins);
        })
        .catch(() => setAdmins(blankAdmins));
    };

    const dedupeAdmins = (items: AdminUserOption[]): AdminUserOption[] => {
      const uniqueAdmins = items.filter((item) => item.userID !== 0);
      const uniqueMap = new Map<number, AdminUserOption>();
      uniqueAdmins.forEach((item) => {
        if (!uniqueMap.has(item.userID)) {
          uniqueMap.set(item.userID, item);
        }
      });
      return Array.from(uniqueMap.values());
    };

    const getRecentAdmins = (): AdminUserOption[] => {
      try {
        const raw = localStorage.getItem(recentAdminsStorageKey);
        if (!raw) return [];
        const parsed = JSON.parse(raw);
        return Array.isArray(parsed) ? dedupeAdmins(parsed).slice(0, 4) : [];
      } catch {
        return [];
      }
    };

    const saveRecentAdmin = (admin: AdminUserOption) => {
      const nextAdmins = [admin, ...getRecentAdmins().filter((item) => item.userID !== admin.userID)].slice(0, 4);
      localStorage.setItem(recentAdminsStorageKey, JSON.stringify(nextAdmins));
    };

    const loadInitialAdmins = async () => {
      const recentAdmins = getRecentAdmins();
      if (recentAdmins.length > 0) {
        setAdmins(recentAdmins);
        return;
      }

      try {
        const response = await orderServices.getadminuserdetails("");
        if (response?.length) {
          setAdmins(dedupeAdmins(response).slice(0, 4));
        } else {
          setAdmins(blankAdmins);
        }
      } catch {
        setAdmins(blankAdmins);
      }
    };

    const handleAdminChange = (e: DropdownChangeEvent) => {
      const id = e.value as number | null;
      setSelectedAdminId(id);
      if (!id) {
        setLockedField(null);
        setRecipientPhone("");
        return;
      }
      const admin = admins.find((a) => a.userID === id);
      if (admin) {
        saveRecentAdmin(admin);
      }
      const mobile = String(admin?.primaryContactNbr || "").replace(/\D/g, "").slice(-10);
      setRecipientPhone(mobile);
      setLockedField("admin");
    };

    const handleRecipientPhoneChange = async (value: string) => {
      const sanitizedPhone = value.replace(/\D/g, "").slice(0, 10);
      setRecipientPhone(sanitizedPhone);

      if (!sanitizedPhone) {
        setSelectedAdminId(null);
        setLockedField(null);
        return;
      }

      if (sanitizedPhone.length < 10) {
        setSelectedAdminId(null);
        setLockedField(null);
        return;
      }

      const existingAdmin = admins.find(
        (admin) => String(admin?.primaryContactNbr || "").replace(/\D/g, "").slice(-10) === sanitizedPhone
      );
      if (existingAdmin) {
        setSelectedAdminId(existingAdmin.userID);
        setLockedField("phone");
        saveRecentAdmin(existingAdmin);
        return;
      }

      try {
        const response = await orderServices.getadminuserdetails(sanitizedPhone);
        const matchedAdmin = dedupeAdmins(response || []).find(
          (admin) => String(admin?.primaryContactNbr || "").replace(/\D/g, "").slice(-10) === sanitizedPhone
        );

        if (matchedAdmin) {
          const nextAdmins = dedupeAdmins([matchedAdmin, ...admins]);
          setAdmins(nextAdmins);
          setSelectedAdminId(matchedAdmin.userID);
          setLockedField("phone");
          saveRecentAdmin(matchedAdmin);
          return;
        }

        setSelectedAdminId(null);
        setLockedField(null);
      } catch {
        setSelectedAdminId(null);
        setLockedField(null);
      }
    };

    const resetWhatsAppSelection = () => {
      setShowWhatsAppModal(false);
      setRecipientPhone("");
      setSelectedAdminId(null);
      setLockedField(null);
      setAdmins(blankAdmins);
    };

    // Custom cell for 'type' - colored text with background
    const typeBody = (rowData: MovementLog) => {
      let color: string;
      let backgroundColor: string;

      switch (rowData.movementType) {
        case "Inward":
          color = "#22c55e"; // Green
          backgroundColor = "#f0fdf4"; // Light green background
          break;
        case "Outward":
          color = "#3b82f6"; // Blue
          backgroundColor = "#eff6ff"; // Light blue background
          break;
        case "Adjust":
          color = "#f59e0b"; // Orange/Amber
          backgroundColor = "#fffbeb"; // Light orange background
          break;
        default:
          color = "#6b7280"; // Gray
          backgroundColor = "#f9fafb"; // Light gray background
      }

      return (
        <span style={{
          color: color,
          backgroundColor: backgroundColor,
          padding: '4px 12px',
          borderRadius: '6px',
          fontWeight: '500',
          fontSize: '0.875rem'
        }}>
          {rowData.movementType}
        </span>
      );
    };

    const dateBody = (rowData: MovementLog) => {
      const dt = new Date(rowData.createdDate);
      return dt.toLocaleDateString('en-GB');
    };

    // Filterable column header component
    const FilterableColumnHeader = ({
      title,
      filterValue,
      onFilterChange,
      options,
      sortField: columnField,
      showSort = true
    }: {
      title: string;
      filterValue: string[];
      onFilterChange: (value: string[]) => void;
      options: string[];
      sortField?: string;
      showSort?: boolean;
    }) => {
      const isCurrentlySorted = sortField === columnField;
      const activeFilterCount = filterValue.length;

      return (
        <div className="flex align-items-center gap-2" style={{ whiteSpace: 'nowrap' }}>
          <span className="font-semibold">{title}</span>

          <div className="flex align-items-center gap-1">
            {/* Filter dropdown */}
            <div className="p-overlay-badge">
              <MultiSelect
                value={filterValue}
                options={options}
                onChange={(e) => onFilterChange(e.value)}
                placeholder={`Filter ${title}`}
                maxSelectedLabels={0}
                selectedItemsLabel={`${activeFilterCount} selected`}
                className="custom-multiselect"
                style={{
                  width: '40px',
                  height: '32px',
                }}
                panelStyle={{ minWidth: '200px' }}
                display="chip"
                pt={{
                  root: {
                    style: {
                      border: activeFilterCount > 0 ? '2px solid #22c55e' : '1px solid #d1d5db',
                      borderRadius: '6px',
                      background: activeFilterCount > 0 ? '#f0fdf4' : 'white',
                      transition: 'all 0.3s ease',
                    }
                  },
                  trigger: {
                    style: {
                      width: '100%',
                      padding: '0',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }
                  },
                  label: {
                    style: { display: 'none' }
                  }
                }}
              >
                <template>
                  <div className="flex align-items-center justify-content-center" style={{ width: '100%' }}>
                    <i
                      className="pi pi-filter"
                      style={{
                        fontSize: '0.9rem',
                        color: activeFilterCount > 0 ? '#22c55e' : '#6b7280'
                      }}
                    />
                    {activeFilterCount > 0 && (
                      <span
                        className="ml-1 badge-custom"
                        style={{
                          background: '#22c55e',
                          color: 'white',
                          borderRadius: '10px',
                          padding: '0 5px',
                          fontSize: '0.65rem',
                          fontWeight: 'bold',
                          minWidth: '16px',
                          textAlign: 'center'
                        }}
                      >
                        {activeFilterCount}
                      </span>
                    )}
                  </div>
                </template>
              </MultiSelect>
            </div>

            {/* Sort buttons */}
            {showSort && columnField && (
              <Button
                icon={isCurrentlySorted && sortOrder === -1 ? "pi pi-sort-amount-down" : "pi pi-sort-amount-up"}
                className="p-button-text p-button-sm"
                onClick={() => handleSort(columnField)}
                style={{
                  color: isCurrentlySorted ? '#22c55e' : '#6b7280',
                  padding: '4px 8px',
                  minWidth: 'auto',
                  transition: 'all 0.3s ease'
                }}
                tooltip={`Sort ${isCurrentlySorted ? (sortOrder === 1 ? 'Descending' : 'Ascending') : 'Ascending'}`}
                tooltipOptions={{ position: 'top' }}
              />
            )}
          </div>
        </div>
      );
    };

    return (
      <div className="col-12">
        <Toast ref={toastRef} />
        {/* Section Header */}
        <div className="flex align-items-center gap-2 mb-3 px-2">
          <div style={{
            backgroundColor: 'rgb(76, 175, 80)',
            borderRadius: '8px',
            padding: '8px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <i className="pi pi-list" style={{ color: 'white', fontSize: '1.2rem' }}></i>
          </div>
          <span style={{ fontWeight: '600', color: '#2d3748', fontSize: '1.1rem' }}>Movement Records</span>
        </div>

        <div className="card p-2" style={{ borderRadius: '12px' }}>
          {/* Header Actions: Export and Clear Filters */}
          {(filteredData.length > 0 || hasActiveFilters) && (
            <div className="flex justify-content-end mb-2 gap-2">
              {/* Export Button */}
              {filteredData.length > 0 && (
                <>
                  <FileActionButton action="export"
                    label="Export"
                    icon="pi pi-download"
                    className="export-btn-summary-tooltip"
                    onClick={handleExportDownload}
                    style={{
                      backgroundColor: '#22c55e',
                      border: 'none',
                      color: 'white',
                      borderRadius: '6px',
                      padding: '0.5rem 1rem',
                      fontSize: '0.9rem'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.background = '#16a34a';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.background = '#22c55e';
                    }}
                    tooltip={`Export & Share ${filteredData.length} record${filteredData.length !== 1 ? 's' : ''}`}
                    tooltipOptions={{ position: 'top' }}
                  />
                  <Button
                    label="WhatsApp"
                    icon="pi pi-send"
                    className="whatsapp-btn-summary-tooltip"
                    type="button"
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      loadInitialAdmins();
                      setShowWhatsAppModal(true);
                    }}
                    style={{
                      backgroundColor: '#25D366',
                      borderColor: '#25D366',
                      color: 'white',
                      borderRadius: '6px',
                      padding: '0.5rem 1rem',
                      fontSize: '0.9rem'
                    }}
                    tooltip="Share Excel via WhatsApp"
                    tooltipOptions={{ position: 'top' }}
                  />
                </>
              )}

              {/* Clear All Filters Button */}
              {hasActiveFilters && (
                <Button
                  label="Clear All Filters"
                  icon="pi pi-filter-slash"
                  className="p-button-outlined p-button-sm"
                  onClick={clearAllFilters}
                  style={{
                    borderColor: '#22c55e',
                    color: '#22c55e',
                    transition: 'all 0.3s ease'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = '#22c55e';
                    e.currentTarget.style.color = 'white';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = 'transparent';
                    e.currentTarget.style.color = '#22c55e';
                  }}
                />
              )}
            </div>
          )}

          <DataTable
            value={filteredData}
            loading={loading}
            paginator
            rows={10}
            rowsPerPageOptions={[10, 25, 50, 100]}
            paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
            currentPageReportTemplate="{first} to {last} of {totalRecords}"
            emptyMessage="No records found"
            stripedRows
            className="pos-movements-table"
          >
            <Column
              body={typeBody}
              header={
                <FilterableColumnHeader
                  title="Type"
                  filterValue={typeFilter}
                  onFilterChange={setTypeFilter}
                  options={typeOptions}
                  sortField="movementType"
                />
              }
              style={{ minWidth: '11rem' }}
            />

            <Column
              header="Date"
              body={dateBody}
              style={{ minWidth: '7.5rem' }}
            />

            <Column
              field="productName"
              header={
                <FilterableColumnHeader
                  title="Product"
                  filterValue={productFilter}
                  onFilterChange={setProductFilter}
                  options={productOptions}
                  sortField="productName"
                />
              }
              style={{ minWidth: '14rem' }}
            />

            <Column
              field="quantity"
              header="Quantity"
              sortable
              style={{ minWidth: '7rem' }}
            />

            <Column
              field="sourceType"
              header={
                <FilterableColumnHeader
                  title="Source Type"
                  filterValue={sourceTypeFilter}
                  onFilterChange={setSourceTypeFilter}
                  options={sourceTypeOptions}
                  sortField="sourceType"
                />
              }
              style={{ minWidth: '12.5rem' }}
            />

            <Column
              field="sourceValue"
              header={
                <FilterableColumnHeader
                  title="Source / Reference"
                  filterValue={sourceRefFilter}
                  onFilterChange={setSourceRefFilter}
                  options={sourceRefOptions}
                  sortField="sourceValue"
                />
              }
              style={{ minWidth: '14rem' }}
            />

            <Column
              field="documentDetails"
              header="Document Details"
              sortable
              style={{ minWidth: '11rem' }}
            />

            <Column
              field="createdByName"
              header="Created By"
              sortable
              style={{ minWidth: '11rem' }}
            />

            <Column
              field="createdByPhone"
              header="Phone"
              sortable
              style={{ minWidth: '10rem' }}
            />


            <Column
              field="note"
              header="Note"
              sortable
              style={{ minWidth: '9.5rem' }}
            />
          </DataTable>

          {/* WhatsApp Modal */}
          <Dialog
            header={
              <div className="flex align-items-center gap-2">
                <i className="pi pi-send" style={{ color: '#25D366', fontSize: '1.5rem' }}></i>
                <span>Share Movement Log via WhatsApp</span>
              </div>
            }
            visible={showWhatsAppModal}
            style={{ width: '450px' }}
            onHide={resetWhatsAppSelection}
            maskStyle={{ backgroundColor: 'rgba(0,0,0,0.5)' }}
            draggable={false}
            resizable={false}
          >
            <div className="grid p-fluid">
              <div className="col-12 mb-3">
                <p className="text-gray-600 mb-2">Select an Admin or enter a mobile number to share the Excel report.</p>
              </div>

              <div className="col-12 mb-3">
                <label className="block mb-2 font-medium">Search Admin</label>
                <Dropdown
                  value={selectedAdminId}
                  options={admins}
                  optionLabel="name"
                  optionValue="userID"
                  filter
                  onFilter={handleAdminFilter}
                  onChange={handleAdminChange}
                  onShow={loadInitialAdmins}
                  placeholder="Type to search admin..."
                  className="w-full"
                  disabled={lockedField === "phone" || isSendingWhatsApp}
                />
              </div>

              <div className="col-12 mb-4">
                <label className="block mb-2 font-medium">Recipient WhatsApp Number</label>
                <div className="p-inputgroup">
                  <span className="p-inputgroup-addon">+91</span>
                  <input
                    type="text"
                    className="p-inputtext w-full"
                    placeholder="10-digit number"
                    value={recipientPhone}
                    readOnly={lockedField === "admin" || isSendingWhatsApp}
                    onChange={(e) => {
                      void handleRecipientPhoneChange(e.target.value);
                    }}
                  />
                </div>
                {recipientPhone.length === 10 && !hasMatchedAdmin && (
                  <small className="p-error block mt-2">
                    No admin found for this number. Please select a valid admin.
                  </small>
                )}
              </div>

              <div className="col-12 flex justify-content-end gap-2 mt-2">
                <Button
                  label="Cancel"
                  className="p-button-text p-button-secondary"
                  onClick={resetWhatsAppSelection}
                  disabled={isSendingWhatsApp}
                />
                <Button
                  label={isSendingWhatsApp ? "Sending..." : "Send via WhatsApp"}
                  icon={isSendingWhatsApp ? "pi pi-spin pi-spinner" : "pi pi-send"}
                  className="p-button-success"
                  type="button"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    handleWhatsAppReferral();
                  }}
                  disabled={isSendingWhatsApp || !hasMatchedAdmin}
                  style={{ backgroundColor: '#25D366', borderColor: '#25D366' }}
                />
              </div>
            </div>
          </Dialog>

          <style>{`
          .custom-multiselect .p-multiselect-trigger {
            padding: 0 !important;
          }
         
          .custom-multiselect .p-multiselect-label {
            display: none !important;
          }
 
          .pos-movements-table .p-datatable-thead > tr > th {
            background: linear-gradient(to bottom, #f9fafb, #f3f4f6);
            border-bottom: 2px solid #e5e7eb;
            padding: 1rem 0.75rem;
          }
 
          .pos-movements-table .p-datatable-thead > tr > th:hover {
            background: linear-gradient(to bottom, #f0fdf4, #dcfce7);
            transition: background 0.3s ease;
          }
 
          .pos-movements-table .p-multiselect-panel .p-multiselect-header {
            background: #f0fdf4;
            border-bottom: 2px solid #22c55e;
          }
 
          .pos-movements-table .p-multiselect-panel .p-multiselect-item:hover {
            background: #dcfce7;
          }
 
          .pos-movements-table .p-multiselect-panel .p-multiselect-item.p-highlight {
            background: #22c55e;
            color: white;
          }
 
          .pos-movements-table .p-button:hover {
            transform: scale(1.1);
            transition: transform 0.2s ease;
          }
        `}</style>
        </div>
      </div>
    );
  }
);